import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  public url: string;
  protected headers: HttpHeaders = new HttpHeaders();

  constructor(private http: HttpClient) {
    this.url = environment.api.url;
    this.headers = this.headers.set('Content-Type', 'application/json');
  }

  public async get(route: string): Promise<HttpResponse<any> | any> {
    return await this.http.get(this.url + route, {headers: this.headers}).toPromise() as any;
  }

  public async post(route: string, data?: any): Promise<HttpResponse<any> | any> {
    return await this.http.post(this.url + route, JSON.stringify(data), {headers: this.headers}).toPromise() as any;
  }

  public async put(route: string, data?: any): Promise<HttpResponse<any> | any> {
    return await this.http.put(this.url + route, JSON.stringify(data), {headers: this.headers}).toPromise() as any;
  }

  public async patch(route: string, data?: any): Promise<HttpResponse<any> | any> {
    return await this.http.patch(this.url + route, JSON.stringify(data), {headers: this.headers}).toPromise() as any;
  }

  public async delete(route: string): Promise<HttpResponse<any> | any> {
    return await this.http.delete(this.url + route, {headers: this.headers}).toPromise() as any;
  }
}
